import React, { forwardRef } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { useTranslation } from 'react-i18next';

// Register the required components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const LineChart = forwardRef((props, ref) => {
  const { t } = useTranslation();

  const data = {
    labels: ['0', '1', '2', '3', '4', '5'],
    datasets: [
      {
        label: t("Bladder Tank"),
        data: props?.firstChartArrayData?.bt,
        fill: false,
        borderColor: 'rgba(79,129,189,255)',
        tension: 0.1,
        pointRadius: 6,
        pointBackgroundColor: 'rgba(79,129,189,255)',
        pointBorderColor: '#fff',
        pointHoverRadius: 7,
        pointStyle: 'rectRot',
        datalabels: {
          align: 'end', // Align labels to the right
          anchor: 'end', // Position them at the end of the line
          formatter: (value) => `${""}`, // Format the label
          color: 'rgba(79,129,189,255)', // Label color
        },
      },
      {
        label: 'FireDos',
        data: props?.firstChartArrayData?.fd,
        fill: false,
        borderColor: 'rgba(192,80,77,255)',
        tension: 0.1,
        pointRadius: 6,
        pointBackgroundColor: 'rgba(192,80,77,255)',
        pointBorderColor: 'rgba(192,80,77,255)',
        pointHoverRadius: 7,
        pointStyle: 'rect',
        datalabels: {
          align: 'end',
          anchor: 'end', 
          formatter: (value) => `${""}`, 
          color: 'rgba(79,129,189,255)',
        },
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.raw !== null) {
              label += `${t("$")} ${context.raw}`;
            }
            return label;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return `${t("$")} ${props.formatIndianNumber(value)}`;
          },
          maxTicksLimit: 10,
          padding: 10 // Increase padding to separate labels from the edges
        },
      },
      x: {
        beginAtZero: true,
        ticks: {
          padding: 10 // Increase padding to separate labels from the edges
      }
      },
    },
  };


  return (
    <div ref={ref}>
      <Line data={data} options={options} />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5px' }}>
        {/* Blue indicator for Bladder Tank */}
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '15px' }}>
          <div>
            <div className="diamond-container">
              <div className="diamond"></div>
              <div className="line line-right"></div>
              <div className="line line-left"></div>
            </div>
          </div>
          <span style={{ marginLeft: '8px', fontFamily: 'ProximaNovaRegular' }}>{t("Bladder Tank")}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '15px' }}>
          <div>
            <div className="diamond-container">
              <div className="diamond-red"></div>
              <div className="line-red line-right"></div>
              <div className="line-red line-left"></div>
            </div>
          </div>
          <span style={{ marginLeft: '8px', fontFamily: 'ProximaNovaRegular' }}>FireDos</span>
        </div>
      </div>
  </div>
  );
}); 

export default LineChart;